// extracted by mini-css-extract-plugin
export default {"bookie_logo":"base_title_bookie_logo__-KzvT","small_view":"base_title_small_view__xU2sC","element":"base_title_element__t+Yyt"};